import React from "react";
import { Avatar, Card } from "antd";
import ResponsiveTable from "../../../design-system/ResponsiveTable";
import { patient2 } from "../../../commons/PanelImagepath";

import { itemRender, onShowSizeChange } from "../../../commons/PaginationFunction";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const PatientsListDesboard = () => {
  const { t } = useTranslation("dashboard");
  const data = [
    {
      id: 1,
      BuyerID: "#PT001",
      BuyerName: "Charlene Reed",
      Age: "29",
      Address: "4417 Goosetown Drive, Taylorsville, North Carolina, 28681",
      Phone: "8286329170",
      VisitLast: "20 Oct 2019",
      Paid: "$100.00",
      image: patient2
    },
    {
      id: 2,
      BuyerID: "#PT001",
      BuyerName: "Travis Trimble",
      Age: "23",
      Address: "4026 Fantages Way, Brunswick, Maine, 04011 ",
      Phone: "2077299974",
      VisitLast: "22 Oct 2019",
      Paid: "$200.00",
      image: patient2
    },
    {
      id: 3,
      BuyerID: "#PT001",
      BuyerName: "Carl Kelly",
      Age: "29",
      Address: "2037 Pearcy Avenue, Decatur, Indiana, 46733 ",
      Phone: "2607247769",
      VisitLast: "21 Oct 2019",
      Paid: "$250.00",
      image: patient2
    },
    {
      id: 4,
      BuyerID: "#PT001",
      BuyerName: "Michelle Fairfax",
      Age: "25",
      Address: "2037 Pearcy Avenue, Decatur, Indiana, 46733 ",
      Phone: "5043686874",
      VisitLast: "21 Sep 2019",
      Paid: "$150.00",
      image: patient2
    },
    {
      id: 5,
      BuyerID: "#PT001",
      BuyerName: "Gina Moore",
      Age: "23",
      Address: "888 Everette Alley, Hialeah, Florida, 33012 ",
      Phone: "9548207887",
      VisitLast: "18 Sep 2019",
      Paid: "$350.00",
      image: patient2
    }
  ];
  const columns = [
    {
      title: t("Buyer Name"),
      dataIndex: "BuyerName",
      render: (text, record) => (
        <Link to="/admin/profile" className="subadmin-dashboard__person">
          <Avatar size={32} src={record.image} alt="" />
          <span>{text}</span>
        </Link>
      ),
      sorter: (a, b) => a.BuyerName.length - b.BuyerName.length
    },

    {
      title: t("Phone"),
      dataIndex: "Phone",
      sorter: (a, b) => a.Phone.length - b.Phone.length
    },
    {
      title: t("Last Visit"),
      dataIndex: "VisitLast",
      sorter: (a, b) => a.length - b.length
    },
    {
      title: t("Paid"),
      dataIndex: "Paid",
      sorter: (a, b) => a.Paid.length - b.Paid.length
    }
  ];
  return (
    <Card title={t("Employees List")} className="subadmin-dashboard__card">
      <ResponsiveTable
        pagination={{
          total: data.length,
          showTotal: (total, range) =>
            t("pagination.showTotal", {
              rangeStart: range[0],
              rangeEnd: range[1],
              total
            }),
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          itemRender: itemRender
        }}
        columns={columns}
        dataSource={data}
        rowKey={record => record.id}
      />
    </Card>
  );
};
export default PatientsListDesboard;
